import LandingCallEmbed from "./LandingCallEmbed"

export default function GetACall() {
  return (
    <div className="flex w-full h-full justify-center">
      <div className="flex flex-col gap-4 p-8">
        <img src="/vibrato-logo.svg" className="h-12 me-3 pl-4" alt="Vibrato Logo" />
        <LandingCallEmbed />
      </div>
    </div>
  )
}
